export const Perm = {
  USERS_LIST: "registers.users.list",
  USERS_CREATE: "registers.users.create",
  USERS_UPDATE: "registers.users.update",
  USERS_DELETE: "registers.users.delete",
  PAPEIS_LIST: "registers.papeis.list",
  PAPEIS_CREATE: "registers.papeis.create",
  PAPEIS_UPDATE: "registers.papeis.update",
  PAPEIS_DELETE: "registers.papeis.delete",
  LOTES_LIST: "registers.lotes.list",
  LOTES_CREATE: "registers.lotes.create",
  LOTES_UPDATE: "registers.lotes.update",
  LOTES_DELETE: "registers.lotes.delete",
  ALUGUEL_ORCAMENTOS_LIST: "aluguel.orcamentos.list",
  ALUGUEL_ORCAMENTOS_CREATE: "aluguel.orcamentos.create",
  ALUGUEL_ORCAMENTOS_UPDATE: "aluguel.orcamentos.update",
  ALUGUEL_ORCAMENTOS_DELETE: "aluguel.orcamentos.delete",
  ALUGUEL_ORCAMENTOS_APROVAR: "aluguel.orcamentos.aprovar",
  ALUGUEL_CONTRATOS_LIST: "aluguel.contratos.list",
  ALUGUEL_CONTRATOS_CREATE: "aluguel.contratos.create",
  ALUGUEL_CONTRATOS_UPDATE: "aluguel.contratos.update",
  ALUGUEL_CONTRATOS_DELETE: "aluguel.contratos.delete",
  ALUGUEL_MOVIMENTACOES_LIST: "aluguel.movimentacoes.list",
  ALUGUEL_MOVIMENTACOES_CREATE: "aluguel.movimentacoes.create",
  ALUGUEL_MOVIMENTACOES_UPDATE: "aluguel.movimentacoes.update",
  ALUGUEL_MOVIMENTACOES_APROVAR: "aluguel.movimentacoes.aprovar",
  ALUGUEL_FATURAS_LIST: "aluguel.faturas.list",
  ALUGUEL_FATURAS_CREATE: "aluguel.faturas.create",
  ALUGUEL_PRODUTOS_LIST: "aluguel.produtos.list",
  ALUGUEL_MANUTENCAO_CREATE: "aluguel.manutencao.create",
  ALUGUEL_CONFIGURACOES_LIST: "aluguel.configuracoes.list",
  ALUGUEL_CONFIGURACOES_UPDATE: "aluguel.configuracoes.update",
  ESTOQUE_LOCALIZACOES_CREATE: "estoque.localizacoes.create",
  ESTOQUE_LOCALIZACOES_UPDATE: "estoque.localizacoes.update",
  ESTOQUE_LOCALIZACOES_DELETE: "estoque.localizacoes.delete",
  ESTOQUE_ITENS_ENDERECOS_LIST: "estoque.itens-enderecos.list",
  ESTOQUE_ITENS_ENDERECOS_CREATE: "estoque.itens-enderecos.create",
  ESTOQUE_ITENS_ENDERECOS_UPDATE: "estoque.itens-enderecos.update",
  ESTOQUE_ITENS_ENDERECOS_DELETE: "estoque.itens-enderecos.delete",
  ESTOQUE_MOVIMENTOS_CREATE: "estoque.movimentos.create",
  ESTOQUE_INVENTARIOS_LIST: "estoque.inventarios.list",
  ESTOQUE_INVENTARIOS_CREATE: "estoque.inventarios.create",
  ESTOQUE_INVENTARIOS_UPDATE: "estoque.inventarios.update",
  ESTOQUE_SEPARACOES_LIST: "estoque.separacoes.list",
  ESTOQUE_SEPARACOES_CREATE: "estoque.separacoes.create",
  ESTOQUE_SEPARACOES_UPDATE: "estoque.separacoes.update",
  ESTOQUE_FECHAMENTOS_LIST: "estoque.fechamentos.list",
  ESTOQUE_FECHAMENTOS_CREATE: "estoque.fechamentos.create",
  ESTOQUE_CONFIGURACOES_UPDATE: "estoque.configuracoes.update",
  CONFIGURACOES_UPDATE: "registers.configuracoes.update",
} as const;
